import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { Clickable } from '../../types';
import { Group } from '../../atoms/graphs';
import Hoverable, { Options } from '../../utils/hoverable/hoverable';

export interface Props extends Clickable, Options {
  children?: any;
  className?: string;
  height?: number;
  isHovered?: boolean;
  width?: number;
  x?: number;
  y?: number;
}

class HGroup extends React.Component<Props, any> {
  public render() {
    const {
      className,
      children,
      isHovered,
      x,
      y,
      height,
      width,
      onClick,
    } = this.props;

    const hoverClass = isHovered ? 'hovered' : '';

    return (
      <Group
        {...{ x, y }}
        {...onClick && { onClick }}
        className={`${className} ${hoverClass}`}
      >
        <rect {...{ height, width }} />
        {children(isHovered)}
      </Group>
    );
  }
}

const HoverableGroup = Hoverable(HGroup, { svg: true });

export default styled(HoverableGroup)`
  pointer-events: all;

  > rect {
    visibility: hidden;
  }
`;
